import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=313a20cc&"
import script from "./ModalWarning.vue?vue&type=script&lang=js&"
export * from "./ModalWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports